import restaurantMealSchedulesActions from '../actionTypes/restaurantMealSchedulesActions';

const initialState = {
  isLoading: false,
  isSubmitting: false,
  isModalOpen: false
};

const mealSchedulesReducer =  (state = initialState, action) => {
  switch (action.type) {
    case restaurantMealSchedulesActions.toggleCreateScheduleModal:
      return {
        ...state,
        isModalOpen: !state.isModalOpen,
      };
    case restaurantMealSchedulesActions.createMealSchedules:
      return { ...state, isSubmitting: true }
    case restaurantMealSchedulesActions.createMealSchedulesSuccess:
      return { ...state, ...action.payload, isSubmitting: false, isModalOpen: false }
    case restaurantMealSchedulesActions.createMealSchedulesFailed:
      return { ...state, ...action.payload, isSubmitting: false }

    default:
      return state;
  }
};

export default mealSchedulesReducer;
